"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipRemoveButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _chipConstants = require("./chipConstants");
var _chipTheme = require("./chipTheme");
const ChipRemoveButton = (0, _styled.default)("div")`
    margin: 0;
    padding: 0;
    border: none;
    // This is necessary to prevent the button from overflowing the Ursa AvatarChip containers
    border-radius: var(
        --smar--sds--chip--border-radius,
        ${_ref => {
  let {
    themeMode
  } = _ref;
  return `calc(${_chipTheme.chipTheme.borderRadius(themeMode)} * 2)`;
}}
    );
    padding-left: var(--smar--sds--chip--close--padding-left, 0);

    position: absolute;
    right: var(--smar--sds--chip--close--right, 2px);

    // allow 2px above and below.
    height: calc(100% - 4px);
    width: var(
        --smar--sds--chip--close--size,
        calc(${_ref2 => {
  let {
    size,
    themeMode
  } = _ref2;
  return _chipTheme.chipTheme.height[size](themeMode);
}} - 4px)
    );
    --smar--ursa-icons--size: var(--smar--sds--chip--close--size);

    color: inherit;

    // This doesn't do anything in Chrome because it's dealt with in the user-agent-stylesheet
    // But in every other browser it's necessary to vertically center the button.
    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: ${_ref3 => {
  let {
    isReadonly
  } = _ref3;
  return isReadonly ? "auto" : "pointer";
}};

    // Only show on hover.
    opacity: var(${_chipConstants.chipCustomCssProperties.removeButtonOpacity}, 0);

    background-color: var(${_chipConstants.chipCustomCssProperties.backgroundHover});
    &:active {
        background-color: var(${_chipConstants.chipCustomCssProperties.backgroundActive});
    }

    transition: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _chipTheme.chipTheme.motion.animation(themeMode);
}};
`;
exports.ChipRemoveButton = ChipRemoveButton;
//# sourceMappingURL=ChipRemoveButton.js.map